import { StyleSheet } from 'aphrodite'
export default StyleSheet.create({
  cardDeck: {
    maxWidth: '38em',
    margin: '2em auto',
  },
})
